import { PROVIDER_LABELS } from "@/lib/providers";

/**
 * Where the open roles come from: the largest boards and countries in the
 * live index, as bars. It replaced a funnel (250 apply → 60 → 12 → 4) whose
 * numbers nothing in the repo could source — on a page whose headline
 * promise is "nothing invented", the one unsourced figure had to go.
 *
 * Night ground, so the white ramp. No emphasis colour: the point is the
 * shape of the whole list, and length already carries the data.
 */
function label(row) {
  if (row.provider) return PROVIDER_LABELS[row.provider] || row.provider;
  return row.country;
}

function Column({ title, rows, testPrefix }) {
  const max = Math.max(...rows.map((r) => r.count), 1);
  return (
    <div>
      <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-white/55">{title}</div>
      <ol className="mt-4 space-y-2.5">
        {rows.map((r) => (
          <li key={label(r)} className="grid grid-cols-[9rem_1fr_5.5rem] items-center gap-3 text-[13px]" data-testid={`${testPrefix}-${r.provider || r.country}`}>
            <span className="text-white/80 truncate">{label(r)}</span>
            <span className="h-2 rounded-sm bg-white/10 overflow-hidden" aria-hidden="true">
              <span className="block h-full bg-white/60" style={{ width: `${(r.count / max) * 100}%` }} />
            </span>
            <span className="font-mono tabular-nums text-white/70 text-right">{r.count.toLocaleString()}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default function SourcesBoard({ sources, totals }) {
  const providers = sources?.providers || [];
  const countries = sources?.countries || [];
  if (!providers.length && !countries.length) return null;
  const roles = totals?.open_roles;
  return (
    <figure className="border border-white/12 rounded-sm bg-white/[0.03] p-7" data-testid="sources-board">
      <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-white/55">
        Where the {roles ? `${(roles / 1e6).toFixed(2).replace(/\.?0+$/, "")}M ` : ""}open roles come from
      </div>
      <div className="mt-6 grid md:grid-cols-2 gap-x-12 gap-y-8">
        {providers.length > 0 && <Column title="By board" rows={providers} testPrefix="source-provider" />}
        {countries.length > 0 && <Column title="By country" rows={countries} testPrefix="source-country" />}
      </div>
      <figcaption className="mt-6 text-xs text-white/50">
        Counted from the live index, not typed in
        {totals?.ats_systems ? ` — ${providers.length} of ${totals.ats_systems} boards` : ""}
        {totals?.countries ? ` and ${countries.length} of ${totals.countries} countries shown` : ""}
        . Updated with every sweep.
      </figcaption>
    </figure>
  );
}
